var bookshelf = require("../index-extended");

module.exports = bookshelf.model("RemoteDB", {
  entityName: "RemoteDB",
  tableName: "remote_db",
});
